import find from "lodash/find";
import get from "lodash/get";

import { AttributeFragment, AttributeInputTypeEnum, GmProfileFragment, User } from "@/saleor/api";

import { PRODUCT_ATTRIBUTE_VALIDATION_META, REPLACEMENT_MAP } from "./constants";

export const applyValueToCustomiseTemplate = (
	value: string,
	user: User,
	profile?: GmProfileFragment | null
) => {
	let newValue = value;
	if (profile && value) {
		newValue = Object.keys(REPLACEMENT_MAP).reduce<string>((a, c) => {
			const replacement = REPLACEMENT_MAP[c];
			const replaceValue =
				typeof replacement.getter === "string"
					? get<GmProfileFragment, keyof GmProfileFragment>(profile, replacement.getter)
					: replacement.getter(profile!, user);
			return a.replaceAll(c, replaceValue);
		}, value);
	}
	return newValue;
};

export const normalizePreferenceValue = (
	attribute: AttributeFragment,
	value?: string | null,
	profile?: GmProfileFragment | null,
	user?: User
) => {
	switch (attribute.inputType) {
		case AttributeInputTypeEnum.RichText:
			if (user && value) {
				return applyValueToCustomiseTemplate(value, user, profile);
			}
			return value;
		default:
			return value;
	}
};

export type PeronsalizeValidationMeta = {
	required: boolean;
	maxLength?: number;
};

export type ProductPersonalizeValidationMeta = {
	[key: string]: PeronsalizeValidationMeta;
};

export const getAttributesValidationMeta = (
	attributes: AttributeFragment[]
): ProductPersonalizeValidationMeta => {
	return attributes.reduce<ProductPersonalizeValidationMeta>((a, c) => {
		const meta: PeronsalizeValidationMeta = { required: true };
		const maxLengthMeta = find(c.metadata, {
			key: PRODUCT_ATTRIBUTE_VALIDATION_META.maxLength.key,
		});
		if (maxLengthMeta) {
			meta.maxLength = Number(maxLengthMeta.value);
		}

		a[c.id] = meta;
		return a;
	}, {});
};
